<template lang="html">
<div class="svg-wrap spark-line">
    <svg class="spark-line-chart">

    </svg>
</div>
</template>

<script>
import * as d3 from 'd3';
// import tooltipMixin from '@/mixins/tooltip';
import valueDotsMixin from '@/mixins/d3SparklineValueDots';

export default {
    mixins: [
        // tooltipMixin,
        valueDotsMixin,
    ],
    props: {
        chartData: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            // layout elements
            wrapper: null, // svg wrapper div (same size/position)
            svgEl: null,
            // dimensions of the chart, not the svg
            chartWidth: 400,
            chartHeight: 200,
            margin: {
                top: 5,
                right: 6,
                bottom: 5,
                left: 6,
            },
            gChart: null,

            // scales
            xScaleTime: null,
            yScaleLinear: null,
        };
    },
    // define date ranges and initialize chart
    mounted() {
        this.wrapper = this.$el;
        this.svgEl = this.$el.querySelector('svg');
        this.svg = d3.select(this.svgEl);

        this.init();
    },
    methods: {
        init() {
            // define chart margins/dimensions
            this.chartWidth = this.wrapper.clientWidth - this.margin.left - this.margin.right;
            this.chartHeight = this.wrapper.clientHeight - this.margin.top - this.margin.bottom;

            const data = this.chartData;

            const dateMin = d3.min(data, d => d.d);
            const dateMax = d3.max(data, d => d.d);
            // const valMin = d3.min(data, d => d.v);
            const valMin = 0;
            const valMax = d3.max(data, d => d.v);

            // x scale
            this.xScaleTime = d3.scaleTime()
                .rangeRound([0, this.chartWidth])
                .domain([dateMin, dateMax]);

            this.yScaleLinear = d3.scaleLinear()
                .rangeRound([this.chartHeight, 0])
                .domain([valMin, valMax])
                .nice();

            const line = d3.line()
                .defined(d => d.v)
                .x(d => this.xScaleTime(d.d))
                .y(d => this.yScaleLinear(d.v))
                .curve(d3.curveMonotoneX);

            // chart container group
            this.gChart = this.svg.append('g')
                .attr('class', 'chart-elements')
                .attr('transform', `translate(${this.margin.left},${this.margin.top})`);

            // add chart sparkline path
            this.gChart.append('path')
                .datum(data)
                .attr('class', 'line')
                .attr('d', line);

            // add dot at the end
            this.addCurrentDot();

            // add
            // this.addValueDots();

            // add tooltip listeners
            // this.addTooltipListeners();
        },
    },
};
</script>

<style lang="scss">
.svg-wrap {
    position: relative;
    width: 300px;
    height: 46px;
    margin: 2px;
}

svg.spark-line-chart {
    // &:hover {
    //     path {
    //         stroke-width: 3px;
    //         stroke: #00F;
    //     }
    // }
    width: 100%;
    height: 100%;
    background-color: red;
    path {
        fill: none;
        stroke-width: 2px;
        stroke: #42A5F5;
    }

    circle {
        &.value-dot {
            fill: orange;
        }
    }

    .mouse-observer-overlay {
        fill: transparent;
        pointer-events: all;
        shape-rendering: crispedges;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/D3Sparkline.vue